var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ObjectUtil = function () {
    function ObjectUtil() {
        _classCallCheck(this, ObjectUtil);
    }

    _createClass(ObjectUtil, null, [{
        key: 'get',


        /**
         * Get a value from a nested object using a path, inspired by lodash.
         * Path can be a string of dot-separated keys or an Array
         *
         * @param {?Object} object
         * @param {Array|string} path
         * @param {*} [defaultValue]
         */
        value: function get(object, path, defaultValue) {

            var result = undefined;
            if (object != null) {
                path = this.toPathArray(path, object);

                var i = 0;
                while (object != null && i < path.length) {
                    object = object[path[i++]];
                }
                result = i && i === path.length ? object : undefined;
            }

            return result === undefined ? defaultValue : result;
        }

        /**
         * @private
         * @param {Array|string} path
         * @param {Object} object
         * @returns {*|*[]}
         */

    }, {
        key: 'toPathArray',
        value: function toPathArray(path, object) {
            if (Array.isArray(path)) {
                return path;
            }
            if (Object.hasOwn(object, path)) {
                return [path];
            }
            return path.split('.');
        }
    }]);

    return ObjectUtil;
}();

export default ObjectUtil;
;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lib/ObjectUtil.js
// module id = 69
// module chunks = 0